import { Button } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import PsyDialog from "../../PsyDialog/PsyDialog";
import { isPopup } from "../isPopup.HOC";
import { useTranslation } from "react-i18next";

const SessionExpiredPopup = ({ setOptions }) => {
  const history = useHistory();
  const { t } = useTranslation(["components"]);

  return (
    <PsyDialog
      open
      title={t("components:session_expired.title")}
      onClose={() => {
        setOptions({
          open: false,
        });
      }}
      renderActions={() => (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push("/login");
              setOptions({
                open: false,
              });
            }}
          >
            {t("components:session_expired.go_login")}
          </Button>
        </>
      )}
    >
      {t("components:session_expired.message")}
    </PsyDialog>
  );
};
export default isPopup(SessionExpiredPopup, "sessionExpiredPopup");
